import { useContext } from "react";
import { EmailTemplateContext } from "../EmailTemplateContext";
import { ButtonElement } from "../elements/ButtonElement";
import { Divider } from "../elements/Divider";
import { EmailNotificationHeader as Header } from "../elements/EmailNotificationHeader";
import { List } from "../elements/List";
import { Mailtext } from "../elements/Mailtext";
import { Plaintext } from "../elements/Plaintext";
import backpack from "@/assets/images/email/backpack.png";

export const PathCongrats = () => {
  const ctx = useContext(EmailTemplateContext);

  if (!ctx) return null;

  const {
    data,
    template: { template },
  } = ctx;

  return (
    <>
      <Plaintext template={template[2]!} innerRef={data.current[2]} />
      <Plaintext template={template[3]!} innerRef={data.current[3]} />
      {template[5]?.text && <Divider imageSrc={backpack} />}
      {template[4]?.text && <Header template={template[4]} innerRef={data.current[4]} />}
      {template[5]?.text && <List template={template[5]} innerRef={data.current[5]} />}
      <ButtonElement template={template[6]!} innerRef={data.current[6]} />
      <Plaintext template={template[7]!} innerRef={data.current[7]} />
      <Mailtext template={template[8]!} innerRef={data.current[8]} />
      <Plaintext template={template[9]!} innerRef={data.current[9]} />
      <Plaintext template={template[10]!} innerRef={data.current[10]} />
    </>
  );
};
